import React from 'react';
import withAuth from '../../withAuth';
import { Container, Box, Typography, Button, Stack } from '@mui/material';
import { Logout as LogoutIcon, DeleteForever as DeleteIcon } from '@mui/icons-material';
import { useVerifyEmail } from '../../hooks/useVerifyEmail';
import { useLogin } from '../../hooks/useLogin';

const StudentProfile: React.FC = () => {
    const { handleDeleteAccount } = useVerifyEmail();
    const { logout } = useLogin();

    return (
        <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
            <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Student Profile
                </Typography>
                <Typography variant="body1">
                    Student profile management coming soon.
                </Typography>

                <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<LogoutIcon />}
                        onClick={logout}
                        data-testid="profile-logout-button"
                    >
                        Logout
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        startIcon={<DeleteIcon />}
                        onClick={handleDeleteAccount}
                        data-testid="profile-delete-button"
                    >
                        Delete Account
                    </Button>
                </Stack>
            </Box>
        </Container>
    );
};

export default withAuth(StudentProfile);
